import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import useForm from '../utils/useForm';

const useBorrowerSettingsForm = (onSubmit, values) => {
  const { t } = useTranslation();

  const fields = useMemo(
    () => [
      {
        title: t('BorrowerSettingsPage.Settings'),
        isTitleHidden: true,
        fields: [
          {
            title: t('common.forms.labels.Email'),
            name: 'email',
            type: 'text',
            validation: 'email',
            required: true,
          },
          {
            title: t('common.forms.labels.Password'),
            name: 'password',
            type: 'password',
          },
          {
            title: t('common.forms.labels.Confirm Password'),
            name: 'password_confirmation',
            type: 'password',
            customValidation: [
              'passwords-match',
              t('common.forms.validation.Passwords must match'),
              function (value) {
                return value === this.parent.password;
              },
            ],
          },
          {
            title: t('common.forms.labels.Language Preference'),
            name: 'preference_language',
            type: 'select',
            required: true,
            options: [
              { label: t('common.forms.options.English'), value: 'English' },
              { label: t('common.forms.options.Spanish'), value: 'Spanish' },
            ],
          },
        ],
      },
    ],
    [t]
  );

  return useForm({ fields, onSubmit, values, onlyValuesPresentInForm: true });
};

export default useBorrowerSettingsForm;
